var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.105,
    height: 20.625,
    viewBox: "0 0 23.105 20.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_splash_1476283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M29.345,15.127c.864,2.591,1.234,6.416-2.961.74-1.357-1.851-5.429,1.6-1.11,3.084,4.442,1.6,3.948,3.7-.74,3.825-3.455.123-5.059,5.059.37,1.727,3.7-2.221,4.195.37,2.838,2.344-2.714,4.072,3.825,6.539,3.084,1.234-.494-3.208,2.591-2.714,2.838-1.357.37,3.331,6.662.864,2.344-1.234-1.357-.74-1.357-3.084.123-2.468,6.909,2.961,7.4-3.7,1.974-2.591-2.591.494-2.344-.617-1.6-1.11,4.688-2.961-.494-6.416-2.714-.247-.37,1.357-2.344.74.123-3.948C35.638,11.8,27.741,10.315,29.345,15.127Z",
    transform: "translate(-18.686 -10.488)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 0.981,
    cy: 0.98,
    rx: 0.981,
    ry: 0.98,
    transform: "matrix(-0.076, -0.997, 0.997, -0.076, 5.431, 18.845)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 0.981,
    cy: 0.98,
    rx: 0.981,
    ry: 0.98,
    transform: "matrix(-0.076, -0.997, 0.997, -0.076, 19.785, 17.309)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.981,
    cy: 0.98,
    rx: 0.981,
    ry: 0.98,
    transform: "matrix(-0.076, -0.997, 0.997, -0.076, 15.244, 2.105)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 0.544,
    cy: 0.544,
    rx: 0.544,
    ry: 0.544,
    transform: "translate(15.555 20.432) rotate(-94.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 0.468,
    cy: 0.468,
    rx: 0.468,
    ry: 0.468,
    transform: "matrix(-0.076, -0.997, 0.997, -0.076, 0.071, 13.334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.b478ebc6911859c3fa1e908c0e0a6020.svg";
export { ForwardRef as ReactComponent };